import { useEffect } from 'react';
import initializeFreshbots from '@utils/freshbotsInit';
import { useRouter } from 'next/router';
import { useSelectorToStore, useDispatchToStore } from '@hooks/reduxHooks';
import { onChatOpen, fetchMeData } from '@actions/helpCenter';

const SupportPage = () => {
  const router = useRouter();
  const dispatch = useDispatchToStore();
  const meData = useSelectorToStore(({ auth }) => {
    return {
      accessToken: auth.accessToken,
      me: auth.me,
      isLoggedIn: auth.isLoggedIn,
      selectedGoal: auth.selectedGoal?.uid
    };
  });

  const { user_role } = router.query;
  useEffect(() => {
    const roles = { 1: 'learner', 2: 'educator' };
    const promises = [];
    promises.push(
      dispatch(
        onChatOpen(roles[user_role], meData.me ? meData.me.jwtToken : '')
      )
    );
    promises.push(
      dispatch(
        fetchMeData(roles[user_role], meData.me ? meData.me.jwtToken : '')
      )
    );
    Promise.all(promises).then((response) => {
      if (response[1]) {
        initializeFreshbots('/support', meData, response[1].result);
      }
    });
  }, [dispatch, meData, meData.me, user_role]);

  return <div />;
};

SupportPage.pageInfo = {
  name: 'Unacademy Support',
  layoutOptions: {
    hideIntercom: true,
    hideFreshbot: true
  }
};

export default SupportPage;
